import React from "react";
import Sidebar from "./Sidebar.js";

interface Props {
  children: React.ReactNode;
}

export default function AppLayout({ children }: Props) {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="app-content">
        {children}
      </main>
    </div>
  );
}
